<template>
    <div class="center-member-add">
        <center-add-title>{{$t("message.cmember.addTitle")}}</center-add-title>
        <div class="center-member-add-content">
            <slot name="addForm"></slot>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        centerAddTitle: () => import("@/components/center/centerAddTitle"),
    }
}
</script>

<style scoped>
.center-member-add{
    margin-top: 30px;
    padding-bottom: 20px;
    background: #fff;
}
.center-member-add-content{
    padding-right: 10px;
}
</style>